'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  fullWidth: false,
  dense: false,
  bordered: false
};
/** Prop Receivers */

var sizeProps = function sizeProps(_ref) {
  var dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      bordered = _ref.bordered,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.selectBox.selectBox,
      styleKey = bordered ? 'bordered' : 'underlined';
  var source = path[styleKey].size;
  if (dense && !fullWidth) source = path[styleKey].size.dense;else if (dense && fullWidth) source = path[styleKey].size.denseFullWidth;else if (!dense && fullWidth) source = path[styleKey].size.fullWidth;
  var _source = source,
      paddingY = _source.paddingY,
      paddingX = _source.paddingX,
      lineHeight = _source.lineHeight,
      fontSize = _source.fontSize;
  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    min-height: ' + lineHeight + 'em;\n  ';
};
/** Styles */


var ButtonTextStyled = exports.ButtonTextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'ButtonTextStyled'
})(['overflow:hidden;text-overflow:ellipsis;flex-grow:1;', ';'], sizeProps);

ButtonTextStyled.propTypes = propTypes;
ButtonTextStyled.defaultProps = defaultProps;
ButtonTextStyled.displayName = 'ButtonTextStyled';